import type { Day } from '@my-fullstack-app/itinerary-types';

function extractTown(address: string): string | undefined {
  const parts = address.split(',').map((s) => s.trim()).filter(Boolean);
  return parts.length > 0 ? parts[parts.length - 1] : undefined;
}

/** Return just the suffix (custom label or town), or undefined if neither. */
export function getDayLabelSuffix(day: Day): string | undefined {
  if (day.label) return day.label;
  const firstAddress = day.places[0]?.address;
  if (firstAddress) return extractTown(firstAddress);
  return undefined;
}

/**
 * Compute the display label for a day.
 * Returns the custom label if set, otherwise the town from the first place.
 * Falls back to "Day N" when neither is available.
 */
export function getDayDisplayLabel(day: Day, dayIndex: number): string {
  return getDayLabelSuffix(day) ?? `Day ${dayIndex + 1}`;
}
